import { Action } from "redux"

export const CLOSE_EDITOR = "CONTRACTS_CLOSE_EDITOR"
export const CLOSE_REPORT = "CONTRACTS_CLOSE_REPORT"
export const ENABLE_CONTRACT = "CONTRACTS_ENABLE_CONTRACT"
export const INITIALIZE = "CONTRACTS_INITIALIZE"
export const RECEIVE_CONTRACT = "CONTRACTS_RECEIVE_CONTRACT"
export const RECEIVE_CONTRACTS = "CONTRACTS_RECEIVE_CONTRACTS"
export const RECEIVE_GLOBAL_SETTINGS = "CONTRACTS_RECEIVE_GLOBAL_SETTINGS"
export const RECEIVE_REPORT = "CONTRACTS_RECEIVE_REPORT"
export const REPAIR_CONTRACT = "CONTRACTS_REPAIR_CONTRACT"
export const REQUEST_CONTRACT = "CONTRACTS_REQUEST_CONTRACT"
export const REQUEST_CONTRACTS = "CONTRACTS_REQUEST_CONTRACTS"
export const REQUEST_GLOBAL_SETTINGS = "CONTRACTS_REQUEST_GLOBAL_SETTINGS"
export const SET_INITIALIZED = "CONTRACTS_SET_INITIALIZED"
export const UPDATE_GLOBAL_SETTINGS = "CONTRACTS_UPDATE_GLOBAL_SETTINGS"
export const VALIDATE_CONTRACT = "CONTRACTS_VALIDATE_CONTRACT"

export interface ContractIdentifier extends Action {
    id: string
}

export interface GlobalSettings extends Action {
    settings: Contracts.GlobalSettings
}

export interface RequestContracts extends Action {
    validate: boolean
}

export interface ReceiveContracts extends Action {
    contracts: Contracts.Contract[]
}

export interface ReceiveContract extends Action {
    contract: Contracts.Contract
}

export interface EnableContract extends ContractIdentifier {
    enabled: boolean
}

export interface ReceiveReport extends Action {
    data: Contracts.ReportData
}

export const closeEditor = (): Action => ({ type: CLOSE_EDITOR })

export const closeReport = (): Action => ({ type: CLOSE_REPORT })

export const enableContract = (
    id: string,
    enabled: boolean,
): EnableContract => ({ type: ENABLE_CONTRACT, id, enabled })

export const initialize = (): Action => ({ type: INITIALIZE })

export const receiveContract = (
    contract: Contracts.Contract,
): ReceiveContract => ({ type: RECEIVE_CONTRACT, contract })

export const receiveContracts = (
    contracts: Contracts.Contract[],
): ReceiveContracts => ({ type: RECEIVE_CONTRACTS, contracts })

export const receiveGlobalSettings = (
    settings: Contracts.GlobalSettings,
): GlobalSettings => ({ type: RECEIVE_GLOBAL_SETTINGS, settings })

export const receiveReport = (data: Contracts.ReportData): ReceiveReport => ({
    type: RECEIVE_REPORT,
    data,
})

export const repairContract = (id: string): ContractIdentifier => ({
    type: REPAIR_CONTRACT,
    id,
})

export const requestContract = (id: string): ContractIdentifier => ({
    type: REQUEST_CONTRACT,
    id,
})

export const requestContracts = (validate: boolean): RequestContracts => ({
    type: REQUEST_CONTRACTS,
    validate,
})

export const requestGlobalSettings = (): Action => ({
    type: REQUEST_GLOBAL_SETTINGS,
})

export const setInitialized = (): Action => ({ type: SET_INITIALIZED })

export const updateGlobalSettings = (
    settings: Contracts.GlobalSettings,
): GlobalSettings => ({ type: UPDATE_GLOBAL_SETTINGS, settings })

export const validateContract = (id: string): ContractIdentifier => ({
    type: VALIDATE_CONTRACT,
    id,
})

export const mapDispatchToProps = {
    closeEditor,
    closeReport,
    enableContract,
    initialize,
    receiveContract,
    receiveContracts,
    receiveGlobalSettings,
    receiveReport,
    repairContract,
    requestContract,
    requestContracts,
    requestGlobalSettings,
    setInitialized,
    updateGlobalSettings,
    validateContract,
}

export type DispatchProps = typeof mapDispatchToProps
